import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import {
  sugerirCodigoSubTipo,
  cadastrarSubTipo,
  atualizarSubTipo,
} from '~/Services/TipoAtendimentoService';

const schemaSubTipo = Yup.object({
  descricao: Yup.string()
    .trim()
    .required('Descrição é obrigatória')
    .max(50, 'Máximo 50 caracteres'),
});

const ModalSubTipo = ({ show, onHide, modo, dados, codAtendimento, onSucesso }) => {
  const [codigoSugerido, setCodigoSugerido] = useState('');

  useEffect(() => {
    if (!show) return;
    if (modo === 'criar' && codAtendimento) {
      sugerirCodigoSubTipo(codAtendimento)
        .then((res) => setCodigoSugerido(res.codigo_sugerido))
        .catch(() => setCodigoSugerido(''));
    } else if (modo === 'editar' && dados) {
      setCodigoSugerido(dados.codigo);
    }
  }, [show, modo, dados, codAtendimento]);

  const initialValues = {
    descricao: dados ? (dados.descricao || '') : '',
  };

  const handleSubmit = async (values, formikBag) => {
    try {
      if (modo === 'criar') {
        await cadastrarSubTipo({
          cod_atendimento: codAtendimento,
          codigo: codigoSugerido,
          descricao: values.descricao.trim(),
        });
        toast.success('SubTipo cadastrado com sucesso.');
      } else {
        await atualizarSubTipo({
          cod_atendimento: codAtendimento,
          codigo: dados.codigo,
          descricao: values.descricao.trim(),
        });
        toast.success('SubTipo atualizado com sucesso.');
      }
      onSucesso();
    } catch (err) {
      const mensagem = err && err.message ? err.message : 'Erro ao salvar.';
      toast.error(mensagem);
    } finally {
      formikBag.setSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton style={{ backgroundColor: '#1a5276', color: '#fff' }}>
        <Modal.Title style={{ fontSize: '1rem', color: '#fff' }}>
          {modo === 'criar' ? 'Novo SubTipo de Atendimento' : 'Editar SubTipo de Atendimento'}
        </Modal.Title>
      </Modal.Header>

      <Formik
        initialValues={initialValues}
        validationSchema={schemaSubTipo}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formik) => (
          <Form onSubmit={formik.handleSubmit}>
            <Modal.Body>
              <Form.Group as={Row} className="mb-2">
                <Form.Label column sm={4} className="text-right font-weight-bold">
                  Código
                </Form.Label>
                <Col sm={8}>
                  <Form.Control
                    type="text"
                    value={codigoSugerido}
                    readOnly
                    style={{ backgroundColor: '#f5f5f5' }}
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row} className="mb-2">
                <Form.Label column sm={4} className="text-right font-weight-bold">
                  Descrição <span className="text-danger">*</span>
                </Form.Label>
                <Col sm={8}>
                  <Field
                    as={Form.Control}
                    type="text"
                    name="descricao"
                    maxLength={50}
                    autoFocus
                    isInvalid={!!formik.errors.descricao}
                  />
                  <ErrorMessage
                    name="descricao"
                    component="div"
                    className="invalid-feedback d-block"
                  />
                </Col>
              </Form.Group>
            </Modal.Body>

            <Modal.Footer>
              <Button variant="secondary" onClick={onHide} disabled={formik.isSubmitting}>
                Cancelar
              </Button>
              <Button variant="primary" type="submit" disabled={formik.isSubmitting}>
                {formik.isSubmitting ? 'Salvando...' : 'Salvar'}
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default ModalSubTipo;
